module.exports = __webpack_public_path__ + "img/dep_drinks@3x.8e93ae71.png";